import { render, staticRenderFns } from "./ModalSuporteSalaCirurgica.vue?vue&type=template&id=8de566ac&scoped=true"
import script from "./ModalSuporteSalaCirurgica.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteSalaCirurgica.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteSalaCirurgica.vue?vue&type=style&index=0&id=8de566ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de566ac",
  null
  
)

export default component.exports